import { Cart } from '../domain';

/*
 ** The cart.discountSpendings are neccessary to get the correct discount later.
 ** These are calculated in the cartManipulation (inside addEligibleOffersToCart), which
 ** is triggered by the updateCartCallback when the discountCode is changed.
 */
export function getTotalSpending(cart: Cart | undefined): number {
  if (!cart) {
    return 0;
  }

  if (window.GIFTBOX_FORCE_USE_TOTAL_PRICE) {
    return cart.total_price;
  }

  return cart.discountSpendings?.total_spending ?? cart.original_total_price;
}

export function getDiscount(
  cart: Cart | undefined,
  totalSpending: number,
): number {
  if (!cart) {
    return 0;
  }
  const discount = cart.original_total_price - totalSpending;
  return Math.max(discount, 0);
}
